import { useColorMode } from '@chakra-ui/react';
import { buttonBoxColorStyle } from '../../pages/ForceToUpdatePage';
import { ReactComponent as GradientPlusIcon } from '../../icons/gradient.plus.svg';
import { t } from 'i18next';

const NavigateArtistSelectButton = ({ onClick }: { onClick: () => void }) => {
  const { colorMode } = useColorMode();

  return (
    <div className="relative z-10">
      <div
        className="absolute inset-0 z-[-1] rounded-[100px]"
        style={buttonBoxColorStyle.glowLayerStyle[colorMode]}
      />
      <button
        className="pl-[14px] pr-[18px] py-[11px] border-none rounded-[100px] flex flex-row items-center gap-[4px]"
        type="button"
        style={buttonBoxColorStyle.bgColorStyle[colorMode]}
        onClick={onClick}
      >
        <GradientPlusIcon width={15} height={15} />
        <p
          className="text-[14px] font-semibold leading-[17px]"
          style={buttonBoxColorStyle.textColorStyle[colorMode]}
        >
          {t('requestArtistSelectPopup.selectButton')}
        </p>
      </button>
    </div>
  );
};

export default NavigateArtistSelectButton;
